<template>
  <Navigation
    v-if="isVisible"
    :is-minimal="isMinimal"
    :is-visible="isVisible"
    :user-initials="userInitials"
    :menu-items="filteredMenuItems"
    :profile-menu-items="profileMenuItems"
    @sign-out="signOutHandler"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import useAccountFeatureFlagsQuery from '@/composables/queries/useAccountFeatureFlagsQuery'
import Navigation from '@/components/Navbar/Navigation.vue'
import { NAV_PRIMARY, NAV_PROFILE } from '@/constants/Nav'
import { LOGIN_ROUTE_PATH } from '@/constants/Routes'
import logger from '@/logger'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const { user } = storeToRefs(authStore)

const { data: featureFlags, isLoading: isLoadingFeatureFlags } = useAccountFeatureFlagsQuery()

const isVisible = computed(() => {
  return !route.meta?.hideNavbar
})

const isMinimal = computed(() => {
  return !!route.meta?.minimalNav
})

const userInitials = computed(() => {
  if (user.value?.firstName && user.value?.lastName) {
    return `${user.value.firstName[0]}${user.value.lastName[0]}`
  }
  return 'MoT'
})

const filteredMenuItems = computed(() => {
  // Wait for flags to load and be available
  if (isLoadingFeatureFlags.value || !featureFlags.value) {
    return []
  }

  // Create a Set of enabled flag names for efficient lookup
  const enabledFlags = new Set(featureFlags.value.map((flag) => flag.name))

  return NAV_PRIMARY.filter((item) => {
    // Include the item if it doesn't have a featureFlag property,
    // or if it does and the flag name is present in the enabledFlags Set.
    return !item.featureFlag || enabledFlags.has(item.featureFlag)
  })
})

// Profile menu items are not filtered for now
const profileMenuItems = computed(() => NAV_PROFILE)

const signOutHandler = async () => {
  try {
    await authStore.signOut()
    router.push({ path: LOGIN_ROUTE_PATH })
  } catch (error) {
    logger.error({ msg: 'Failed to sign-out', error })
  }
}
</script>
